import Button from "components/molecules/Button";
import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import Form from "components/molecules/Form/Form";
import React, {useState} from "react";
import styled from "styled-components";
import bagIcon from "../../../../../../assets/bagIcon.png";
import deliveryIcon from "../../../../../../assets/deliveryIcon.png";
import dishIcon from "../../../../../../assets/dishIcon.png";
import {useEffect} from "react";

const servings = [
    {
        title: (
            <div style={{display: "flex", alignItems: "center", gap: "6px"}}>
                <img src={dishIcon} alt="icon" />
                Dine-in
            </div>
        ),
        value: "dine-in",
    },
    {
        title: (
            <div style={{display: "flex", alignItems: "center", gap: "6px"}}>
                <img src={deliveryIcon} alt="icon" />
                Delivery
            </div>
        ),
        value: "delivery",
    },
    {
        title: (
            <div style={{display: "flex", alignItems: "center", gap: "6px"}}>
                <img src={bagIcon} alt="icon" />
                Pick-up
            </div>
        ),
        value: "pick-up",
    },
];
const days = [
    {
        title: "MON",
        value: "Monday",
    },
    {
        title: "TUE",
        value: "Tuesday",
    },
    {
        title: "WED",
        value: "Wednesday",
    },
    {
        title: "THU",
        value: "Thursday",
    },
    {
        title: "FRI",
        value: "Friday",
    },
    {
        title: "SAT",
        value: "Saturday",
    },
    {
        title: "SUN",
        value: "Sunday",
    },
];

const timings = [
    "All Time",
    "Breakfast (7:00 AM - 11:00 AM)",
    "Lunch (11:00 AM - 4:00 PM)",
    "Dinner (4:00 PM - 10:00 PM)",
    "Late Night (10:00 PM - 2:00 AM)",
];

export const StyledAvailability = styled(Form)`
    width: 100%;
    .title {
        display: block;
        color: var(--text-color);
        font-size: 24px;
        line-height: 28px;
        font-weight: 400;
        margin-bottom: 20px;
    }
    .tabs-wrap {
        list-style: none;
        display: flex;
        gap: 15px;
        margin-bottom: 20px;
        li {
            border: 1px solid rgba(205, 205, 205, 1);
            border-radius: 30px;
            padding: 5px 10px;
            font-size: 12px;
            line-height: 16px;
            font-weight: 400;
            cursor: pointer;
            &.active {
                color: var(--primary);
                border-color: rgba(245, 126, 42, 0.15);
                background-color: rgba(245, 126, 42, 0.15);
            }
        }
    }
    .items {
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        gap: 15px 33px;
        margin-bottom: 25px;
        li {
            /* width: 100%; */
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 16px;
            padding: 12px 20px 12px 15px;
            border: 1px solid rgba(236, 236, 236, 1);
            border-radius: 10px;
            &.active {
                background-color: rgba(245, 126, 42, 0.1);
                border: 1px solid rgba(245, 126, 42, 0.15);
            }
            .item-name {
                display: block;
                color: var(--text-color);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
            .item-desc {
                color: rgba(119, 119, 119, 1);
                font-size: 12px;
                line-height: 16px;
                font-weight: 400;
            }
            .input-field-wrap {
                margin-bottom: 0;
                label {
                    margin-bottom: 0;
                }
            }
        }
    }
    .servings-item {
        list-style: none;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 15px 21px;
        margin-bottom: 30px;
        @media (min-width: 650px) {
            grid-template-columns: repeat(3, 1fr);
        }
        li {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 16px;
            padding: 12px 20px 12px 15px;
            border: 1px solid rgba(236, 236, 236, 1);
            border-radius: 48px;
            &.active {
                background-color: rgba(245, 126, 42, 0.1);
                border: 1px solid rgba(245, 126, 42, 0.15);
            }
            .item-name {
                display: block;
                color: var(--text-color);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
            .item-desc {
                color: rgba(119, 119, 119, 1);
                font-size: 12px;
                line-height: 16px;
                font-weight: 400;
            }
            .input-field-wrap {
                margin-bottom: 0;
                label {
                    margin-bottom: 0;
                }
            }
        }
    }
    .timings-wrap {
        list-style: none;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 15px 18px;
        margin-bottom: 25px;
        @media (min-width: 768px) {
            grid-template-columns: repeat(2, 1fr);
        }
        li {
            color: var(--text-color);
            border: 1px solid rgba(236, 236, 236, 1);
            border-radius: 60px;
            padding: 10px 20px;
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            transition: all 0.1s ease-in-out;
            @media (min-width: 768px) {
                padding: 20px;
                font-size: 18px;
                line-height: 22px;
            }
            &.active {
                background-color: rgba(245, 126, 42, 0.1);
                border: 1px solid rgba(245, 126, 42, 0.15);
            }
        }
    }
    .input-field-wrap {
        margin-bottom: 30px;
        .label {
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
        }
    }
    .summary-wrap {
        padding: 20px 15px;
        border-radius: 15px;
        background-color: rgba(44, 185, 255, 0.1);
        margin-bottom: 40px;
        .title {
            color: rgba(44, 185, 255, 1);
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
            margin-bottom: 10px;
        }
        .flex {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 12px;
            .price {
                color: var(--text-color);
                font-size: 16px;
                line-height: 20px;
                font-weight: 500;
            }
        }
        .heading {
            display: block;
            color: var(--text-color);
            margin-bottom: 12px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            &:last-child {
                margin-bottom: 0;
            }
            .danger {
                color: rgba(226, 29, 37, 1);
            }
            .desc {
                font-weight: 300;
            }
        }
    }
    .btn-holder {
        @media (min-width: 576px) {
            display: flex;
            gap: 21px;
        }
        .btn {
            width: 100%;
            &:first-child {
                @media (max-width: 575px) {
                    margin-bottom: 10px;
                }
            }
        }
    }
`;

const Availability = ({setActiveTab, formData, setFormData}) => {
    const [form] = useForm();
    const [checkboxes, setCheckboxes] = useState({
        FRI: false,
        MON: false,
        SAT: false,
        SUN: false,
        THU: false,
        TUE: false,
        WED: false,
    });
    const [timeSlot, setTimeSlot] = useState("All Time");

    useEffect(() => {
        if (formData?.form4) {
            setCheckboxes(formData?.form4?.availableDays);
            setTimeSlot(formData?.form4?.timeSlot);
        }
    }, [formData?.form4]);

    async function handleSubmit(e) {
        const step4 = {
            timeSlot: timeSlot,
            availableDays: checkboxes,
            customTimeSlot: e?.customTimeSlot,
        };
        try {
            await setFormData(prev => ({...prev, form4: {...step4}}));
            setActiveTab(4);
        } catch (error) {
            console.log(error);
        }
    }

    const AllDaysCheckboxes = {
        FRI: true,
        MON: true,
        SAT: true,
        SUN: true,
        THU: true,
        TUE: true,
        WED: true,
    };
    const WeekendsCheckboxes = {
        FRI: false,
        MON: false,
        SAT: true,
        SUN: true,
        THU: false,
        TUE: false,
        WED: false,
    };

    function areObjectsEqual(obj1, obj2) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) return false;

        return keys1.every(key => obj1[key] === obj2[key]);
    }

    return (
        <StyledAvailability form={form} onSubmit={handleSubmit}>
            <strong className="title">Days Available</strong>
            <ul className="tabs-wrap">
                <li
                    className={areObjectsEqual(checkboxes, AllDaysCheckboxes) ? "active" : ""}
                    onClick={() => setCheckboxes(AllDaysCheckboxes)}>
                    Select All
                </li>
                <li
                    className={areObjectsEqual(checkboxes, WeekendsCheckboxes) ? "active" : ""}
                    onClick={() => setCheckboxes(WeekendsCheckboxes)}>
                    Weekend
                </li>
            </ul>
            <ul className="items">
                {days?.map((data, index) => (
                    <li key={index} className={checkboxes[data?.title] === true ? "active" : ""}>
                        <Field
                            label={
                                <>
                                    <span className="item-name">{data?.title}</span>{" "}
                                    <span className="item-desc">{data?.value}</span>
                                </>
                            }
                            type="checkbox"
                            name={data?.title}
                            value={checkboxes[data?.title] === true}
                            onChange={() =>
                                setCheckboxes(prev => ({
                                    ...prev,
                                    [data?.title]: !prev[data?.title],
                                }))
                            }
                        />
                    </li>
                ))}
            </ul>
            <strong className="title">Optional Add-ons</strong>
            <ul className="timings-wrap">
                {timings?.map((data, index) => (
                    <li key={index} className={timeSlot === data ? "active" : ""} onClick={() => setTimeSlot(data)}>
                        {data}
                    </li>
                ))}
            </ul>
            <Form.Item
                label="Custom Time Slot"
                $bgWhite
                type="text"
                name="customTimeSlot"
                placeholder="Breakfast (7:00 AM - 11:00 AM)">
                <Field />
            </Form.Item>
            <strong className="title">Serving Methods</strong>

            <ul className="servings-item">
                {servings?.map((data, index) => (
                    <li key={index} className={checkboxes[data?.value] === true ? "active" : ""}>
                        <Field
                            label={
                                <>
                                    <span className="item-name">{data?.title}</span>
                                </>
                            }
                            type="checkbox"
                            name={data?.value}
                            value={checkboxes[data?.value] === true}
                            onChange={() =>
                                setCheckboxes(prev => ({
                                    ...prev,
                                    [data?.value]: !prev[data?.value],
                                }))
                            }
                        />
                    </li>
                ))}
            </ul>

            <div className="summary-wrap">
                <h2 className="title">Availability Summary</h2>
                <div className="flex">
                    <strong className="heading">
                        Available Days:{" "}
                        <span className="danger">
                            {days.filter(day => checkboxes[day.title]).length === 0
                                ? "No days selected"
                                : days
                                      .filter(day => checkboxes[day.title])
                                      .map(day => day.title)
                                      .join(", ")}
                        </span>
                    </strong>
                    <strong className="price">${formData?.form3?.comboPrice ?? 0.0}</strong>
                </div>
                <strong className="heading">
                    Time Slot: <span className="desc">{timeSlot}</span>
                </strong>
                <strong className="heading">
                    Serving Methods: <span className="desc">All methods available</span>
                </strong>
            </div>
            <div className="btn-holder">
                <Button type="button" $gray className="btn" onClick={() => setActiveTab(2)}>
                    Previous
                </Button>
                <Button className="btn">Next</Button>
            </div>
        </StyledAvailability>
    );
};

export default Availability;
